"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyEnterWithInput = useKeyEnterWithInput;
exports.useKeyEnter = useKeyEnter;
var react_1 = require("react");
function useKeyEnterWithInput(_a) {
    var func = _a.func, inputRef = _a.inputRef;
    (0, react_1.useEffect)(function () {
        // Подписываемся на событие keydown
        window.addEventListener("keydown", handleKeyDown);
        // Отписываемся при размонтировании
        return function () {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    var handleKeyDown = function (e) {
        var _a;
        if (e.key === "Enter") {
            e.preventDefault();
            if (document.activeElement === inputRef.current) {
                var newValue = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value.trim();
                if (newValue) {
                    func(newValue);
                    inputRef.current.value = ""; // Очищаем input после добавления
                }
            }
        }
    };
    return null;
}
function useKeyEnter(func) {
    (0, react_1.useEffect)(function () {
        // Подписываемся на событие keydown
        window.addEventListener("keydown", handleKeyDown);
        // Отписываемся при размонтировании
        return function () {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    var handleKeyDown = function (e) {
        if (e.key === "Enter") {
            e.preventDefault();
            func();
        }
    };
    return null;
}
